{
  "tabs": {
    "overview": "Profile overview",
    "notifications": "Notifications"
  },
  "avatar": {
    "drag_and_drop_statement": "Drag and drop your avatar here",
    "or_statement": "Or if you prefer",
    "cta_label": "Select a file from your device"
  },
  "notifications": {
    "title": "Notifications",
    "label": "You have here, the possibility to choose how and when we're allowed to contact you.",
    "cta": {
      "save": "Save"
    },
    "ticket_created": {
      "title": "Creation",
      "label": "Get notified when a ticket is created"
    },
    "step_change": {
      "title": "Step change",
      "label": "Get notified when a ticket you're attached to changes step"
    },
    "ticket_deleted": {
      "title": "Deletion",
      "label": "Get notified when a ticket you're attached to is deleted"
    },
    "comment": {
      "title": "Comment",
      "label": "Get notified when a comment is posted on a ticket you're attached to"
    },
    "mention": {
      "title": "Mention",
      "label": "Get notified when a user mentions you in a comment"
    }
  },
  "ticket_created": {
    "title": "Created",
    "label": "Get notified when a ticket you're attached to is created"
  },
  "step_change": {
    "title": "Step changed",
    "label": "Get notified when a ticket you're attached to changes step"
  },
  "ticket_deleted": {
    "title": "Deleted",
    "label": "Get notified when a ticket you're attached to is deleted"
  },
  "comment": {
    "title": "Comment",
    "label": "Get notified when a comment is posted on a ticket you're attached to"
  },
  "form": {
    "inputs": {
      "firstName": "First name",
      "lastName": "Last name",
      "email": "Email",
      "phone": "Phone number",
      "eps_login": "Login EPS",
      "eps_password": "Password EPS",
      "idahe_login": "Login IDAHE",
      "idahe_password": "Password IDAHE"
    }
  },
  "update": {
    "response_success": "Profile successfully updated"
  }
}
